import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { PlantOptionsService } from './plant-options.service';
import { PlantOptionsInitialState, PlantOptionsLoad } from './plant-options.actions';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface PlantOptionsStateModel {
  options: string[];
  loaded: boolean;
}

const initialState: PlantOptionsStateModel = {
  options: [],
  loaded: false,
};

@State<PlantOptionsStateModel>({
  name: 'plantOptions',
  defaults: initialState,
})
@Injectable()
export class PlantOptionsState {
  constructor(private plantOptionsService: PlantOptionsService, private notificationService: NotificationService) {}

  @Selector()
  static getOptions(state: PlantOptionsStateModel): string[] {
    return state.options;
  }

  @Selector()
  static getLoaded(state: PlantOptionsStateModel): boolean {
    return state.loaded;
  }

  @Action(PlantOptionsLoad)
  getPlantOptions(
    ctx: StateContext<PlantOptionsStateModel>,
    { payload }: PlantOptionsLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.plantOptionsService.getPlants(payload).pipe(
      map((options: string[]) => {
        ctx.patchState({ options, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(PlantOptionsInitialState)
  setInitialState(ctx: StateContext<PlantOptionsStateModel>): void {
    ctx.setState(initialState);
  }
}
